import React from "react";
import { Helmet } from "react-helmet-async";
import { ChevronDown, MessageSquare } from "lucide-react";
import { Link } from "react-router-dom";

const FaqImmobilier = ({ setOpenIndex, openIndex, toggleFAQ, idCategorie }) => {
  const faqList = [
    {
      question: () => (
        <strong>
          1. Pourquoi payer pour publier mon annonce immobilière sur Deal.mg ?
        </strong>
      ),
      answer: () => (
        <p>
          Votre investissement garantit une plateforme sans spam, des
          utilisateurs plus sérieux et une meilleure visibilité de votre{" "}
          <strong>tany amidy</strong> (terrain à vendre) ou{" "}
          <strong>trano hofaina</strong> (maison à louer). De plus, Deal.mg
          propose des outils d'IA pour optimiser la rédaction de votre annonce,
          augmentant vos chances de succès.
        </p>
      ),
    },
    {
      question: () => (
        <strong>2. Comment trouver un bien immobilier dans ma ville ?</strong>
      ),
      answer: () => (
        <p>
          Utilisez la barre de recherche en précisant le type de bien (maison,
          terrain, appartement) et la localisation (ex :{" "}
          <strong>appartement Antananarivo</strong>). Vous pouvez affiner les
          résultats grâce aux filtres géographiques et de prix.
        </p>
      ),
    },
    {
      question: () => (
        <strong>
          3. Quelles sont les vérifications faites sur les annonces immobilières
          ?
        </strong>
      ),
      answer: () => (
        <p>
          Deal.mg est une plateforme de mise en relation.{" "}
          <strong>
            Nous ne vérifions pas juridiquement les documents de propriété.
          </strong>{" "}
          Il est impératif de demander le numéro du titre foncier au vendeur,
          puis d’effectuer une vérification auprès du service des domaines
          compétent afin de confirmer que le titre est valide, au nom du vendeur
          et libre de toute hypothèque.
        </p>
      ),
    },
    {
      question: () => <strong>4. Comment contacter un propriétaire ?</strong>,
      answer: () => (
        <p>
          Le numéro de téléphone ou l’email du propriétaire est directement
          visible sur l’annonce. Vous pouvez le contacter par appel ou SMS pour
          organiser une visite.
        </p>
      ),
    },
    {
      question: () => (
        <strong>5. Puis-je trouver des terrains avec titre foncier ?</strong>
      ),
      answer: () => (
        <p>
          Oui, de nombreux vendeurs précisent si le{" "}
          <strong>terrain à vendre</strong> dispose d’un titre foncier. Nous
          recommandons de demander le numéro du titre et de le vérifier auprès
          des autorités compétentes avant toute transaction.
        </p>
      ),
    },
    {
      question: () => (
        <strong>
          6. Comment sécuriser l'achat d'un terrain ou d'une maison ?
        </strong>
      ),
      answer: () => (
        <p>
          Exigez le titre foncier, vérifiez sa validité auprès des autorités et{" "}
          <strong>finalisez la vente devant un notaire</strong> afin de garantir
          la légalité du transfert.
        </p>
      ),
    },
    {
      question: () => (
        <strong>
          7. Comment faire estimer le prix de mon bien avant de le vendre ?
        </strong>
      ),
      answer: () => (
        <p>
          Comparez les annonces similaires sur Deal.mg dans le même quartier
          pour fixer le juste prix de votre <strong>maison à vendre</strong> et
          maximiser votre retour sur investissement.
        </p>
      ),
    },
    {
      question: () => (
        <strong>8. Comment signaler une annonce immobilière suspecte ?</strong>
      ),
      answer: () => (
        <p>
          Si une annonce vous semble frauduleuse (prix trop bas, photos volées),
          utilisez le bouton « Signaler » situé sur la fiche de l'annonce. Notre
          équipe vérifiera et supprimera le contenu si nécessaire.
        </p>
      ),
    },
    {
      question: () => (
        <strong>
          9. Comment rédiger une annonce immobilière qui attire les acheteurs ?
        </strong>
      ),
      answer: () => (
        <p>
          Soyez précis sur la surface (m²), le nombre de pièces et la
          localisation. Utilisez des photos claires et rédigez une description
          détaillée. Vous pouvez utiliser notre outil d’IA pour générer une
          description optimisée pour le <strong>SEO immobilier</strong>.
        </p>
      ),
    },
    {
      question: () => (
        <strong>10. Les locations à Madagascar sont-elles sécurisées ?</strong>
      ),
      answer: () => (
        <p>
          La sécurité dépend de la vérification initiale. Rencontrez toujours le
          propriétaire, vérifiez l’état des lieux et signez un contrat de bail
          en bonne et due forme pour toute <strong>location de maison</strong>{" "}
          ou d’appartement.
        </p>
      ),
    },
  ];

  return (
    <>
      <Helmet>
        <title>
          Découvrez nos catégories Immobilier au meilleur prix | Deal.mg
        </title>
        <meta
          name="description"
          content={`Découvrez nos catégories Immobilier disponibles à Madagascar sur Deal.mg`}
        />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org/",
            "@type": "Product",
            name: "Immobilier à Madagascar",
            image: ["https://deal.mg/logo.png"],
            description: `Découvrez nos Immobilier disponibles à Madagascar sur Deal.mg`,
            sku: idCategorie,
            offers: {
              "@type": "Offer",
              url: `https://deal.mg/article/resultat?idCategorie=${idCategorie}`,
              availability: "https://schema.org/InStock",
            },
          })}
        </script>
      </Helmet>
      <h1 className="text-center">
        Immobilier à Madagascar : vendez et louez avec efficacité
      </h1>
      <p>
        Trouvez le bien idéal sur Deal.mg, la plateforme qui connecte
        directement acheteurs et locataires avec des propriétaires. Que vous
        cherchiez un {" "}
          <strong> appartement à louer à Tana</strong>
        ou un <strong>terrain à vendre avec titre foncier</strong> à Toamasina,
        notre espace dédié sécurise vos transactions immobilières.
        <br />
        <br />
        Vendez ou louez vos propriétés rapidement en publiant des annonces
        détaillées, valorisées par notre outil d'IA pour un impact maximal
        auprès d'utilisateurs sérieux.
      </p>
      <h2>Vos annonces optimisées pour une visibilité maximale</h2>
      <p>
        Valorisez vos biens immobiliers en publiant des annonces détaillées.
        Grâce à notre outil d'IA intégré, générez une description optimisée pour
        le <strong>SEO immobilier</strong>, garantissant que votre {" "}
          <strong> maison à vendre</strong>
        ou votre <strong>appartement à louer</strong> atteigne les bonnes
        personnes rapidement. La transparence et la fiabilité de notre
        plateforme attirent des utilisateurs engagés, maximisant vos chances de
        conclusion de transaction.
      </p>
      <h2>Un espace de vente sécurisé et sélectif</h2>
      <p>
        <strong>Deal.mg</strong> s'engage à offrir une expérience de vente
        fluide et sécurisée. Le coût de publication permet de filtrer les
        annonces pour ne conserver que des offres authentiques, protégeant ainsi
        les acheteurs et les vendeurs. Ce sérieux profite à l'ensemble de la
        communauté, notamment pour les transactions importantes en {" "}
          <strong>  Électronique</strong>
        ou pour l'aménagement de votre intérieur avec la section {" "}
          <strong> Maison & Jardin</strong>
        .
      </p>
      <br />
      <h2 className="support_faq_title">
        <MessageSquare size={20} className="support_faq_title_icon" />
        FAQ
      </h2>

      {faqList.map((item, index) => (
        <div
          key={index}
          className={`support_faq_item ${openIndex === index ? "open" : ""}`}
        >
          <div
            className="support_faq_question"
            onClick={() => toggleFAQ(index)}
          >
            <span>{item.question()}</span>
            <ChevronDown
              className={`support_faq_arrow ${
                openIndex === index ? "support_faq_rotate_180" : ""
              }`}
              size={20}
            />
          </div>

          <div
            className={`support_faq_answer_container${
              openIndex === index ? "active" : ""
            }`}
          >
            <div className="support_faq_answer">{item.answer()}</div>
          </div>
        </div>
      ))}
    </>
  );
};

export default FaqImmobilier;
